import { apiClient } from './client';

/**
 * Get modules for a course
 * @param {string} courseId
 * @param {{ page?, limit?, sortBy?, sortOrder? }} params
 */
export async function getCourseModules(courseId, params = {}) {
  const { data } = await apiClient.get(`/modules/courses/${courseId}`, { params });
  return data;
}

/**
 * Create a module for a course
 * @param {string} courseId
 * @param {object} body - title, description, orderIndex
 */
export async function createModule(courseId, body) {
  const { data } = await apiClient.post(`/modules/courses/${courseId}`, body);
  return data;
}

/**
 * Update a module
 * @param {string} courseId
 * @param {string} moduleId
 * @param {object} body - title, description, orderIndex
 */
export async function updateModule(courseId, moduleId, body) {
  const { data } = await apiClient.put(`/modules/${moduleId}`, body);
  return data;
}

/**
 * Delete a module
 * @param {string} courseId
 * @param {string} moduleId
 */
export async function deleteModule(courseId, moduleId) {
  const { data } = await apiClient.delete(`/modules/${moduleId}`);
  return data;
}
